export default __webpack_public_path__ + "static/media/handtuchverleih-element.1f802e25.jpg";